/**
 * @ngdoc component
 * @name mx.shell:mxCommonActions
 * @module mx.shell
 * @requires {@ref mx.shell.ActionManagerService mx.shell.ActionManagerService}
 * @requires $scope
 * @description A list of {@ref mx.shell:mxAction action buttons} that are common for current page context
 */

angular.module('mx.shell').component('mxCommonActions', {
	bindings: {},
	controller: MxCommonActionsCtrl,
	controllerAs: 'vm',
	templateUrl: 'components/mx-common-actions/mx-common-actions.html',
});

MxCommonActionsCtrl.$inject = [
	'mx.shell.ActionManagerService',
	'mx.shell.EventService',
	'mx.shell.KeyboardNavigationService',
	'mx.internationalization',
	'$scope',
	'$timeout',
	'mx.shell.SideLayout',
	'mx.shell.RoutingService',
];

function MxCommonActionsCtrl(actionManagerService, eventService, keyboardNavigationService, i18n, $scope, $timeout, sideLayoutService, routingService) {
	if (routingService.getCurrent()?.name === 'globalSearch') {
		return;
	}

	const vm = this;

	vm.$onInit = function () {
		vm.isVisible = true;
		vm.actions = [];
	};

	eventService.subscribeTo(mx.shell.EventCodes.DisplayModeChanged, (event, newMode) => (vm.isVisible = newMode === mx.shell.DisplayMode.Normal), $scope);
	vm.sideLayoutService = sideLayoutService;

	eventService.subscribeTo(
		mx.shell.EventCodes.ActionsContextChanged,
		(eventObj, context) => {
			const actionTypes = [mx.shell.ActionContextType.None];

			if (context && context.uiZone === mx.shell.ActionUiZone.SearchPage) {
				actionManagerService
					.getActions(context, actionTypes, [])
					.then(function (actions) {
						return actionManagerService.filterActions(actions);
					})
					.then(function (filteredActions) {
						vm.actions = filteredActions;
						vm.actions = filteredActions;
					});
			}

			if (!context || context.uiZone === mx.shell.ActionUiZone.LandingPage) {
				vm.actions = [];
			}
		},
		$scope
	);

	vm.$postLink = function () {
		keyboardNavigationService.registerKey({
			callback: function () {
				$timeout(() => $('mx-common-actions .md-button:visible').get(0).click());
			},
			description: i18n.get('shell.mx-common-actions.newObject'),
			key: 'alt+n',
			nameInTemplate: 'newHint',
			scope: $scope,
		});
	};
}
